module.exports = __webpack_public_path__ + "media/images/icon-gyogu-e9c55a903f5509ad160a3c44bfd97a32.png";